import { useEffect, useState, useRef } from 'react'
import { Box, Typography } from '@mui/material'
import RowStack from './container/RowStack'
import colors from 'styles/colors'
import InCardStack from './container/InCardStack'

export const radarGraphLocationString = 'RadarGraph'

const GraphLabel = ({
  x,
  y,
  angle,
  attrKey,
  showScoreLabel,
  selfScore,
  otherScore,
  handleBehaviorNavigation,
  text,
  svgRef,
  disableBehaviorClick
}) => {
  const [position, setPosition] = useState({
    labelOffsetX: 0,
    labelOffsetY: 0
  })
  const labelRef = useRef(null)

  useEffect(() => {
    if (!svgRef.current) return

    const containerBox = svgRef.current.getBoundingClientRect()

    const centerX = containerBox.width * 0.5 // Adjusted
    const centerY = containerBox.height * 0.5 // Adjusted

    // Convert polar coordinates to X, Y positions
    let offsetX = centerX * Math.cos(angle)
    let offsetY = centerY * Math.sin(angle)

    // Fine-tune side adjustments
    if (Math.abs(Math.cos(angle)) > 0.4) {
      let adjustX = labelRef.current?.offsetWidth * 0.7
      adjustX = adjustX > 100 ? adjustX : adjustX + 10

      offsetX +=
        offsetX > 0
          ? adjustX // Right side
          : -adjustX // Left side
    }

    // Fine-tune top/bottom adjustments
    if (Math.abs(Math.sin(angle)) > 0.4) {
      let adjustY = labelRef.current?.offsetHeight * 0.7
      adjustY = adjustY > 50 ? adjustY : adjustY + 15
      offsetY +=
        offsetY > 0
          ? adjustY // Top side
          : -adjustY // Bottom side
    }

    setPosition({
      labelOffsetX: offsetX,
      labelOffsetY: offsetY
    })
  }, [x, y, angle, svgRef])

  return (
    <Box
      ref={labelRef}
      sx={{
        position: 'absolute',
        left: `calc(50% + ${position.labelOffsetX}px)`,
        top: `calc(50% - ${position.labelOffsetY}px)`,
        transform: 'translate(-50%, -50%)', // Center text
        backgroundColor: colors.White,
        borderRadius: 25,
        padding: '8px 16px',
        minWidth: 110,
        maxWidth: 150,
        ...(!disableBehaviorClick && {
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#F8FFFF',
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.20)'
          }
        })
      }}
      onClick={() => handleBehaviorNavigation(attrKey)}>
      <InCardStack spacing={0} sx={{ textAlign: 'center' }}>
        <Typography variant='body1Small' fontWeight={500}>
          {text?.join('')}
        </Typography>

        {showScoreLabel && (
          <RowStack justifyContent='center' spacing={2}>
            <Typography
              variant='body1Small'
              fontWeight={700}
              color={colors.Teal400}>
              {selfScore ? Number(selfScore).toFixed(1) : '-'}
            </Typography>
            <Typography
              variant='body1Small'
              fontWeight={500}
              color={colors.Grey300}>
              /
            </Typography>
            <Typography
              variant='body1Small'
              fontWeight={600}
              color={colors.MidnightTeal400}>
              {otherScore ? Number(otherScore).toFixed(1) : '-'}
            </Typography>
          </RowStack>
        )}
      </InCardStack>
    </Box>
  )
}

export default GraphLabel
